import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUnseen = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4 8.50313L10 4.05938L16 8.50313V9.98438L11.0469 13.6562C10.7437 13.8813 10.3781 14 10 14C9.62187 14 9.25625 13.8781 8.95312 13.6562L4 9.98438V8.50313ZM10 2C9.62187 2 9.25625 2.12188 8.95312 2.34375L2.80937 6.89687C2.3 7.275 2 7.86875 2 8.50313V16C2 17.1031 2.89688 18 4 18H16C17.1031 18 18 17.1031 18 16V8.50313C18 7.86875 17.7 7.27187 17.1906 6.89687L11.0469 2.34375C10.7437 2.12188 10.3781 2 10 2Z",
		fill: "#0D2976"
	})
});
export default SvgUnseen;
